import debounce from 'lodash.debounce';

function getHashTarget(linkEl) {
    if (!linkEl.hash) {
        return null;
    }

    const id = decodeURIComponent(linkEl.hash.slice(1));

    return id ? document.getElementById(id) : null;
}

function activateLink(navbarEl, scrollEl, linkEls) {
    // Use the sticky nav's visible bottom as the "read line". Content anchors in
    // the page builder are empty 0-height modules, so we treat each target as a
    // section start that remains active until the next target reaches the nav.
    // Before any target has been reached, keep the first in-page link active.
    const navbarBottom = navbarEl.getBoundingClientRect().bottom + 1;
    let newActiveIndex = -1;

    linkEls.forEach((el, index) => {
        const sectionEl = getHashTarget(el);

        if (sectionEl === null) {
            return;
        }

        if (newActiveIndex === -1) {
            newActiveIndex = index;
        }

        if (sectionEl.getBoundingClientRect().top <= navbarBottom) {
            newActiveIndex = index;
        }
    });

    const currentActiveIndex = linkEls.findIndex(el => el.classList.contains('is-active'));

    // Do nothing if the link is already active.
    if (newActiveIndex === currentActiveIndex) {
        return;
    }

    const activeLinkEl = linkEls[newActiveIndex];

    linkEls.forEach(el => {
        if (el === activeLinkEl) {
            el.classList.add('is-active');
        } else {
            el.classList.remove('is-active');
        }
    });

    // Scroll to new active link.
    if (typeof activeLinkEl !== 'undefined') {
        const { left, right } = activeLinkEl.getBoundingClientRect();
        const { paddingLeft, paddingRight } = window.getComputedStyle(scrollEl);

        // Only scroll to link when its outside of the viewport.
        if (left < parseFloat(paddingLeft) || right > scrollEl.clientWidth - parseFloat(paddingRight)) {
            scrollEl.scrollLeft = activeLinkEl.offsetLeft - parseFloat(paddingLeft);
        }
    }
}

export default () => {
    const navbarEl = document.querySelector('.js-sustainability-navbar');

    // Do nothing if navbar doesn't exist.
    if (navbarEl === null) {
        return;
    }
        
    const scrollEl = navbarEl.querySelector('.js-sustainability-navbar-scroll');
    const linkEls = [...navbarEl.querySelectorAll('.js-sustainability-navbar-link')];

    // Apply overflow styles when last link is overflowing the scroll container.
    const { paddingRight } = window.getComputedStyle(scrollEl);
    const intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            scrollEl.classList.remove('is-overflow');
        } else {
            scrollEl.classList.add('is-overflow');
        }
    }, {
        threshold: 1,
        rootMargin: `0px -${parseInt(paddingRight)}px`
    });
    intersectionObserver.observe(linkEls[linkEls.length - 1]);

    // Activate link on scroll and initial page load.
    window.addEventListener('scroll', debounce(() => activateLink(navbarEl, scrollEl, linkEls), 20));
    activateLink(navbarEl, scrollEl, linkEls);   
}
